import { lerpColor } from '../../color';
import { hsl, type World } from '../../world';
import { dress, fx } from './dress';
import { paint } from './paint';
import './world.css';

const H = 35;
const S = 34;
const A1 = 350;
const A2 = 160;

const L = hsl(H, 72, 82);
const MY = hsl(A1, 88, 78);
const SPOT = hsl(A2, 85, 76);
const RIM = hsl(H, 45, 92);

const world: World = {
  id: 'roda-de-samba',
  name: 'Roda de Samba',
  seed: 'roda-de-samba',
  legacy: false,
  hue: H,
  ceil: hsl(H, 0.8 * S, 28),
  font: 'Lobster',
  fontFile: 'lobster-400.woff2',
  fontWeight: '400',
  fontLicense: 'OFL-1.1',
  dark: true,
  boil: false,
  glow: 'add',
  glowAlpha: 0.4,
  fillAlpha: 0.72,
  palette: {
    bg: hsl(H, S, 10),
    ink: hsl(H, S + 12, 5),
    rim: RIM,
    held: MY,
    heldShade: hsl(A1, 60, 60),
    heldLight: hsl(A1, 90, 90),
    incoming: { circle: L, square: SPOT, triangle: lerpColor(L, MY, 0.5), hex: lerpColor(L, SPOT, 0.5) },
    spot: SPOT,
    path: hsl(H, 30, 72),
    text: hsl(H, 40, 94),
    sparks: [MY, SPOT, L, RIM],
  },
  burst: { count: 12, speed: 0.55, drag: 3, gravity: 0.5, spin: 5, life: 1, sizeMin: 0.01, sizeMax: 0.024 },
  dress,
  fx,
  paint,
};

export default world;
